module.exports = __webpack_public_path__ + "02_mole.8caab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/02_mole.png
// module id = RjTb
// module chunks = 0